<div class="active warning" mat-dialog-title>{{ 'sla.ui-material.version-check.label' | translate }}</div>

<div mat-dialog-content>
    <h3>{{ 'sla.ui-material.version-check.content' | translate }}</h3>
</div>

<div class="actions" mat-dialog-actions>
    <button class="medium-touch-btn"
            mat-dialog-close
            mat-stroked-button>
        <mat-icon>close</mat-icon>
        {{ 'sla.ui-material.button.cancel.label' | translate }}
    </button>
    <button (click)="ignore()"
            class="medium-touch-btn"
            color="primary"
            mat-stroked-button>
        <mat-icon>update_disabled</mat-icon>
        {{ 'sla.ui-material.version-check.ignore.label' | translate : { time: blockTimeMinutes } }}
    </button>
    <button (click)="reload()"
            class="medium-touch-btn"
            color="primary"
            mat-flat-button>
        <mat-icon>system_update_alt</mat-icon>
        {{ 'sla.ui-material.version-check.reload.label' | translate }}
    </button>
</div>
